export const DATE_FORMAT = 'YYYY-MM-DD';
export const ONE_MIN_IN_MS = 60_000;
export const MAIN_COLOR = '#1976D2';
